import React, { useState } from 'react';
import './App.css';
import { Globe, Code, Server, Mail, CheckCircle } from 'lucide-react';
import ContactForm from './components/ContactForm';

// Import your custom logo
// You'll need to save the SVG logo to your project and update this import
// For now, I'll comment this out and use a placeholder
import logo from './reed-logo.svg';

function App() {
  const [activeService, setActiveService] = useState(null);

  const services = [
    {
      icon: <Globe className="w-12 h-12 text-blue-600" />,
      title: "Web Design",
      description: "Crafting stunning, responsive websites that capture your brand's essence and engage your audience."
    },
    {
      icon: <Code className="w-12 h-12 text-green-600" />,
      title: "Web Development",
      description: "Building robust, scalable web applications using the latest technologies and best practices."
    },
    {
      icon: <Server className="w-12 h-12 text-purple-600" />,
      title: "Consulting",
      description: "Strategic guidance to optimize your online presence and digital infrastructure."
    }
  ];

  return (
    <div className="min-h-screen flex flex-col">
      <main className="flex-grow">
        {/* Navigation */}
        <nav className="bg-white shadow-md">
          <div className="max-w-6xl mx-auto px-4 py-4 flex justify-between items-center">
            <div className="flex items-center">
            <div className="flex items-center">
              <img src={logo} alt="Reed Web Consulting Logo" className="h-20 w-20 mr-3" />
            </div>
              <span className="text-2xl font-bold text-gray-800">Reed Web Consulting</span>
            </div>
            <div className="space-x-6">
              <Mail 
                className="text-white hover:text-blue-300 cursor-pointer" 
                onClick={() => window.location.href = 'mailto:contact@reedwebconsulting.com'}
              />
              {/* <a href="#services" className="text-gray-700 hover:text-blue-600">Services</a> */}
              {/* <a href="#about" className="text-gray-700 hover:text-blue-600">About</a> */}
              <a className="text-gray-700 hover:text-blue-600 cursor-pointer"
                onClick={() => window.location.href = 'mailto:contact@reedwebconsulting.com'}>Contact</a>
            </div>
          </div>
        </nav>

        {/* Hero Section */}
        <header className="bg-blue-600 text-white text-center py-20">
          <h1 className="text-5xl font-bold mb-4">Transform Your Digital Presence</h1>
          <p className="text-xl max-w-2xl mx-auto mb-8">
            We deliver cutting-edge web solutions that drive business growth and create memorable online experiences.
          </p>
          {/* <a 
            href="#contact" 
            className="bg-white text-blue-600 px-8 py-3 rounded-full font-semibold hover:bg-blue-100 transition"
          >
            Get Started
          </a> */}
        </header>

        {/* Services Section */}
        <section id="services" className="py-16 px-4">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-4xl font-bold text-center mb-12">Our Services</h2>
            <div className="grid md:grid-cols-3 gap-8">
              {services.map((service, index) => (
                <div 
                  key={index} 
                  className="bg-white p-6 rounded-lg shadow-md text-center hover:shadow-xl transition-all"
                  onMouseEnter={() => setActiveService(index)}
                  onMouseLeave={() => setActiveService(null)}
                >
                  <div className="flex justify-center mb-6">
                    {service.icon}
                  </div>
                  <h3 className="text-2xl font-semibold mb-4">{service.title}</h3>
                  <p className="text-gray-600">{service.description}</p>
                  {/* {activeService === index && (
                    <div className="mt-4 text-green-600 flex items-center justify-center">
                      <CheckCircle className="mr-2" />
                      <span>Learn More</span>
                    </div>
                  )} */}
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Contact Section - Replace with imported component */}
        {/* <ContactForm /> */}
      </main>
      <footer className="bg-gray-800 text-white py-8">
        <div className="max-w-6xl mx-auto px-4 text-center">
          <p>&copy; 2024 Reed Web Consulting. All Rights Reserved.</p>
          <div className="flex justify-center space-x-4 mt-4">
            <Mail 
              className="text-white hover:text-blue-300 cursor-pointer" 
              onClick={() => window.location.href = 'mailto:contact@reedwebconsulting.com'}
            />
            {/* <Globe className="text-white hover:text-blue-300 cursor-pointer" /> */}
          </div>
        </div>
      </footer>
    </div>
  );
};

export default App;